export enum IconLogo {
    Logo = 'logo',
    LogoEntreprise = 'logo_entreprise',
    LogoMarcel = 'logo_marcel',
    AppIcon = 'app_icon',
}

export enum IconAxel {
    AirportDeparture = 'airport_departure',
    AirportTower = 'airport_tower',
    ArrowLeft = 'arrow_left',
    Briefcase = 'briefcase',
    CalendarCheck = 'calendar_check',
    CalendarClock = 'calendar_clock',
    Card = 'card',
    CarFront = 'car_front',
    CarSide = 'car_side',
    Check = 'check',
    Clock = 'clock',
    Copy = 'copy',
    CopyPaste = 'copy_paste',
    Download = 'download',
    Driver = 'driver',
    DropOff = 'dropoff',
    DropOffPin = 'dropoff_pin',
    EmptyHistory = 'empty_history',
    EmptyInProgress = 'empty_in_progress',
    EmptySchedule = 'empty_schedule',
    Filters = 'filtres',
    Finger = 'finger',
    Flag = 'flag',
    FolderLock = 'folder_lock',
    Geolocalisation = 'geolocalisation',
    HeartHands = 'heart_hands',
    Help = 'help',
    Home = 'home',
    Leaf = 'leaf',
    LineCurve = 'line_curve',
    Localisation = 'localisation', // Pin
    LocationIndicator = 'location_indicator', // current Location
    Luggage = 'luggage',
    MapCarWickedIcon = 'map_car_wicked_icon',
    Obp = 'obp',
    Pause = 'pause',
    Pencil = 'pencil',
    Phone = 'phone',
    Pickup = 'pickupV2',
    PickupPin = 'pickup_pin',
    Plane = 'plane',
    Plus = 'plus',
    Radio = 'radio',
    RadioChecked = 'radio_checked',
    Recurrence = 'recurrence',
    RecurrenceRound = 'recurrence_round',
    Search = 'search',
    Star = 'star',
    StepFinal = 'step_final',
    StepGeolocation = 'step_geolocation',
    StepNotification = 'step_notification',
    StepWelcome = 'step_welcome',
    Swap = 'swap',
    Ticket = 'ticket',
    TicketPromo = 'ticket_promo',
    Train = 'train',
    User = 'user',
    UserContact = 'user_contact',
    Users = 'users',
    Warning = 'warning',
}

export enum IconCommon {
    AlertCircle = 'alert_circle',
    AlertProfil = 'alert_profil',
    Badge = 'badge',
    BadgeOutline = 'badge_outline',
    Briefcase = 'briefcase',
    BriefcaseOutline = 'briefcase_outline',
    Calendar = 'calendar',
    CalendarClock = 'calendar_clock',
    CardOutline = 'card_outline',
    Check = 'check',
    ChevronDown = 'chevron_down',
    ChevronDown2 = 'chevron_down_2',
    ChevronRight = 'chevron_right',
    CircleClose = 'circle_close',
    CirclePlus = 'circle_plus',
    Clock = 'clock',
    ClockOutline = 'clock_outline',
    Close = 'close',
    CoinsStack = 'coins_stack',
    Debug = 'debug',
    Document = 'document',
    DownloadImport = 'download_import',
    DropOffPin = 'drop_off_pin',
    Email = 'email',
    Export = 'export',
    Eye = 'eye',
    EyeOff = 'eye_off',
    Filters = 'filters',
    FreeDestination = 'free_destination',
    Gauge = 'gauge',
    Gear = 'gear',
    Home = 'home',
    Information = 'information',
    InformationOutline = 'information_outline',
    Lock = 'lock',
    MapCarIcon = 'map_car_icon',
    MapLocationTarget = 'map_location_target',
    // MeetingPointPin = 'meeting_point_pin',
    MenuBurger = 'menu_burger',
    Mouse = 'mouse',
    Offline = 'offline',
    PageListing = 'page_listing',
    Pancarte = 'pancarte',
    PenEdit = 'pen_edit',
    Pin = 'pin',
    PickUpPin = 'pick_up_pin',
    PinLocation = 'pin_location',
    PlaneTakeOff = 'plane_take_off',
    Radio = 'radio',
    RadioChecked = 'radio_checked',
    RailroadTrain = 'railroad_train',
    SelfServiceOffers = 'self_service_offers',
    SelfServiceOffersMobile = 'self_service_offers_mobile',
    Share = 'share',
    SosOutline = 'sos_outline',
    StarsFull = 'stars_full',
    StarsOutline = 'stars_outline',
    Switch = 'switch',
    Tick = 'tick',
    Trash = 'trash',
    User = 'user',
    UserOutline = 'user_outline',
    UserOutlineMultiple = 'user_outline_multiple',
    Warning = 'warning',
    WheelOutline = 'wheel_outline',
}

export enum IconService {
    Berline = 'berline',
    Classic = 'classic',
    Green = 'green',
    Moto = 'moto',
    Prestige = 'prestige',
    Van = 'van',
    Taxi = 'taxi',
    Access = 'access_v2',
    //Events
    Wicked = 'wicked',
}

export enum IconError {
    Error = 'error',
}

export enum Animation {
    CarFront = 'car_front',
    Flag = 'flag',
    Loader = 'loader',
    Localisation = 'localisation',
}

export enum ImageEvent {
    WickedModal = 'wicked_modal_hd',
    WickedBandeau = 'wicked_bandeau',
    WickedDetails = 'wicked_details',
    WickedMenu = 'wicked_menu',
}
